export default "__VITE_ASSET__Bxs8trY$__"